import React, {Fragment, useEffect, useState} from "react";
import {getBanner} from "../../redux/actions/";
import {APP} from "../../constants";
import {Responsive} from "semantic-ui-react";
import moment from "moment";

const getWidth = () => {
    const isSSR = typeof window === 'undefined';

    return isSSR ? Responsive.onlyTablet.minWidth : window.innerWidth
};

export const Banner = React.memo((params) => {

    const [now, setNow] = useState(moment().unix());
    const [banner, setBanner] = useState({});

    function tick() {

        setNow(moment().unix());
    }

    useEffect(() => {

        let timerID = setInterval(() => tick(), 15000);

        return function cleanup() {
            clearInterval(timerID);
        };
    }, []);

    useEffect(() => {

        const fetchData = async () => {

            try {

                // get places
                const result = await getBanner(params);

                // clear old banner
                setBanner({});

                // set new banner
                setTimeout(() => setBanner(result.data.data[0] || {}), 600);
            } catch (e) {

                // show errors
                console.log('error', e);
            }
        };

        // noinspection JSIgnoredPromiseFromCall
        fetchData();

    }, [params, now]);

    let desktop = '';
    let mobile = '';
    let link = APP.API_URL;
    let align = '';

    if (banner.id) {

        desktop = APP.banner + '/image/' + banner.image;
        mobile = APP.banner + '/mobile/' + banner.mobile;
        link = link + '/banners/view/' + banner.id;
    }

    if (params.align) {

        align = params.align;
    }

    return (
        <Fragment>
            {
                banner.id && <div className={`banner ${align} ${params.type || "P"}`}>
                    <a href={link} target={'_blank'}>
                        <Responsive getWidth={getWidth} minWidth={Responsive.onlyTablet.minWidth}>
                            <img src={desktop} className={'desktop'}/>
                        </Responsive>
                        <Responsive getWidth={getWidth} maxWidth={Responsive.onlyMobile.maxWidth}>
                            <img src={mobile} className={'mobile'}/>
                        </Responsive>
                    </a>
                </div>
            }
        </Fragment>
    );
});
